// Content of the "Mobile Numerology Consultation Policy" (Vaidik Vidhya™).
const mobileNumerologyPolicyData = {
  badge: "MOBILE NUMEROLOGY POLICY",
  pageTitle: "Mobile Numerology Consultation Policy - Vaidik Vidhya",
  heading: "Mobile Numerology Consultation Policy",
  tagline: "Vaidik Vidhya™ - an initiative of AstroLogical Solutions™.",
  intro:
    "This policy explains the terms and conditions applicable to Mobile Numerology consultations, personalised mobile number analysis, number selection, order processing and related SIM delivery services offered through Vaidik Vidhya™. By submitting an order or making a payment, the customer acknowledges that they have had the opportunity to review the applicable service description, charges, timelines and policies.",
  highlights: ["Scope of Service", "Fees & Payment", "Cancellation & Refund", "SIM Delivery", "Privacy"],
  sections: [
    {
      title: "Purpose of the Policy",
      paragraphs: [
        "This policy explains the terms and conditions applicable to Mobile Numerology consultations, personalised mobile number analysis, number selection, order processing and related SIM delivery services offered through Vaidik Vidhya™.",
        "By submitting an order or making a payment, the customer acknowledges that they have had the opportunity to review the applicable service description, charges, timelines and policies.",
      ],
    },
    {
      title: "Scope of Consultation",
      paragraphs: [
        "Our Mobile Numerology service involves personalised analysis based on the customer's supplied birth details, Ascendant Horoscope, relevant planetary placements and numerological number chart. The consultation may include:",
      ],
      bullets: [
        "Analysis of birth details and Ascendant Horoscope.",
        "Assessment of relevant planetary placements and houses in relation to the customer's stated objective.",
        "Numerological evaluation of suitable mobile number patterns.",
        "Recommendation and shortlisting of a suitable number, subject to availability.",
        "Guidance regarding confirmation, ordering and SIM delivery, where included in the selected package.",
      ],
      after: ["The precise scope of the service will depend on the package selected and confirmed at checkout."],
    },
    {
      title: "Accuracy of Customer Information",
      paragraphs: [
        "Customers are responsible for providing accurate and complete information, including their name, date of birth, birth time, place of birth and contact details.",
        "If any essential information is missing or inaccurate, Vaidik Vidhya™ may request clarification before proceeding.",
        "Any resulting delay in analysis or number selection may affect the expected completion timeline.",
      ],
    },
    {
      title: "Personalised Recommendations",
      paragraphs: [
        "Every recommendation is prepared with reference to the information provided by the individual customer and the traditional astrological and numerological framework used for the consultation.",
        "A recommended number is not a guarantee of any particular personal, professional, financial, marital or other outcome.",
        "Astrology and numerology are traditional interpretive practices. Customers should continue to use their own judgement and seek appropriate professional advice for medical, legal, financial, business and other important decisions.",
      ],
    },
    {
      title: "Consultation Process and Timelines",
      paragraphs: [
        "The consultation process begins after the required information and applicable payment have been received and confirmed, in accordance with the selected package.",
        "If additional information is required, the customer will be informed.",
        "The estimated timeline for analysis, recommendation, number confirmation and delivery will be communicated according to the service purchased. Timelines may be affected by incomplete information, number availability, operator requirements, KYC verification or logistics.",
      ],
    },
    {
      title: "Number Availability and Selection",
      paragraphs: [
        "All mobile numbers are subject to availability and the relevant telecom operator's rules.",
        "A number may not be available when the order is processed, even if it appeared available earlier.",
        "Where a proposed number becomes unavailable, Vaidik Vidhya™ will communicate the situation and, where feasible, offer other alternatives. If the number became unavailable due to the delay or negligence of the customer, the alternatives will depend on the circumstances and Vaidik Vidhya™ reserves the right of final decision.",
        "If a suitable alternative cannot be arranged, the applicable refund or cancellation terms will be communicated before the order is closed.",
      ],
    },
    {
      title: "Fees and Payment",
      paragraphs: [
        "All applicable consultation fees, package charges, taxes, SIM charges and delivery charges, where relevant, will be disclosed before payment.",
        "Customers should review the selected package and total payable amount before completing the transaction.",
        "Payments should be made only through the payment methods officially provided or authorised by Vaidik Vidhya™.",
        "Customers should retain their payment confirmation and order reference for future communication.",
      ],
    },
    {
      title: "Cancellation and Refund Policy",
      paragraphs: ["Refund eligibility depends on the service purchased, the stage of processing and the reason for cancellation, subject to applicable law."],
      bullets: [
        "A. Before consultation work begins: If the customer requests cancellation before any substantive personalised analysis or service work has started, the amount paid will be assessed for refund in accordance with the disclosed cancellation terms and applicable law.",
        "B. After personalised analysis has begun: Once substantive personalised analysis or the agreed consultation work has commenced, the fee for work already performed may be non-refundable to the extent permitted by applicable law. Any unperformed portion of the service will be assessed separately.",
        "C. Service not delivered: If Vaidik Vidhya™ is unable to provide a material part of the service purchased, the customer may be eligible for an appropriate refund or other remedy, subject to the circumstances and applicable law.",
      ],
      after: [
        "Approved refunds will be initiated through the original payment method wherever feasible. The processing period will be communicated to the customer.",
        "Nothing in this policy excludes any refund, remedy or consumer right that cannot lawfully be excluded.",
      ],
    },
    {
      title: "No Guarantee of Results",
      paragraphs: [
        "The service provides a personalised recommendation based on traditional astrological and numerological interpretations.",
        "Vaidik Vidhya™ does not guarantee that a selected mobile number will produce a particular result, change a person's destiny, resolve a specific problem or ensure success in career, business, finance, marriage or other areas of life.",
        "Actual life outcomes depend on many factors, including personal decisions, circumstances and actions.",
      ],
    },
    {
      title: "SIM Delivery and Telecom Services",
      paragraphs: [
        "Where SIM delivery is included in the selected package, fulfilment will be subject to the telecom operator's availability, applicable KYC requirements, activation procedures and delivery arrangements.",
        "Delivery may be coordinated through the designated operator's delivery partner, where applicable.",
        "The customer must provide the required identification and complete the applicable verification process. SIM activation and telecom services remain subject to the relevant operator's terms and regulatory requirements. The customer will be responsible for any delay in receiving service that results from the customer's own action or inaction.",
        "Delivery estimates are indicative unless expressly confirmed otherwise.",
      ],
    },
    {
      title: "Customer Responsibilities",
      paragraphs: ["Customers agree to:"],
      bullets: [
        "Provide accurate information for the consultation and order.",
        "Use the service and SIM in accordance with applicable law.",
        "Complete any required identity verification.",
        "Review the selected number and order details before confirmation.",
        "Keep their order reference and payment confirmation.",
        "Avoid sharing OTPs, UPI PINs, passwords or confidential banking credentials with anyone claiming to represent the service.",
      ],
    },
    {
      title: "Privacy and Confidentiality",
      paragraphs: [
        "Personal information - including date of birth, time of birth, contact details and horoscope reports - will be collected and used only for purposes such as providing the consultation, processing the order, communicating with the customer and arranging delivery where applicable.",
        "Information will be handled in accordance with the published Privacy Policy and applicable data protection requirements.",
        "Only information reasonably required for the relevant purpose should be requested. Information may be shared with authorised payment, technology, fulfilment or telecom service providers where necessary for the requested service and legally permitted.",
        "Customers should not send unnecessary identity documents or sensitive information through unsecured communication channels.",
      ],
    },
    {
      title: "Complaints and Grievance Resolution",
      paragraphs: [
        "Customers may submit a complaint regarding consultation quality, order status, payment, cancellation, refund or delivery through the official contact details published on our website.",
        "Please include the order reference, payment details relevant to the complaint and a brief description of the issue. Do not include passwords, OTPs or UPI PINs.",
        "We will acknowledge and address complaints within the timelines required by applicable law and the grievance policy published on the website.",
      ],
    },
    {
      title: "Limitation of Policy",
      paragraphs: [
        "This policy describes the general terms applicable to the service. Specific package inclusions, confirmed delivery arrangements and any additional conditions will be disclosed before purchase.",
        "If any provision of this policy conflicts with applicable law, the applicable legal requirement will prevail.",
      ],
    },
    {
      title: "Governing Law and Jurisdiction",
      paragraphs: [
        "This policy shall be governed by the laws of India.",
        "Subject to applicable law and the jurisdiction of any consumer commission or other authority that is legally competent to hear a matter, disputes arising from the service shall be subject to the jurisdiction of the competent courts at Muzaffarnagar, Uttar Pradesh, where such jurisdiction is legally available.",
      ],
    },
    {
      title: "Contact Information",
      paragraphs: [
        "Vaidik Vidhya™ - an initiative of AstroLogical Solutions™",
        "Address: Shiva Aangan, Bachan Singh Colony, Lane No. 9, Muzaffarnagar, Uttar Pradesh - 251001",
        "Phone: 8057191573",
        "For consultation, cancellation, refund or order-related assistance, please contact us through the official contact channels published on our website.",
      ],
    },
  ],
};

export default mobileNumerologyPolicyData;
